var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"icon-checkmark",class:{ checked: _vm.adminSettings.banned_from_streaming },attrs:{"title":"Ban streaming"},on:{"click":_vm.toggle}}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Ban user from streaming")])])
}
var staticRenderFns = []

export { render, staticRenderFns }